import { render, staticRenderFns } from "./PropertyDetails2.vue?vue&type=template&id=5d2ba83e&scoped=true&"
import script from "./PropertyDetails2.vue?vue&type=script&lang=js&"
export * from "./PropertyDetails2.vue?vue&type=script&lang=js&"
import style0 from "./PropertyDetails2.vue?vue&type=style&index=0&id=5d2ba83e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2ba83e",
  null
  
)

export default component.exports